module.exports = __webpack_public_path__ + "img/Aland Islands.5bafcc41.svg";